import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=fd5173b8&scoped=true&"
import script from "./Organization.vue?vue&type=script&lang=js&"
export * from "./Organization.vue?vue&type=script&lang=js&"
import style0 from "./Organization.vue?vue&type=style&index=0&id=fd5173b8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5173b8",
  null
  
)

/* custom blocks */
import block0 from "./Organization.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd5173b8')) {
      api.createRecord('fd5173b8', component.options)
    } else {
      api.reload('fd5173b8', component.options)
    }
    module.hot.accept("./Organization.vue?vue&type=template&id=fd5173b8&scoped=true&", function () {
      api.rerender('fd5173b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Organization/Organization.vue"
export default component.exports